import { AdminUserRoles } from "../../../constants/user";

const UserRoles = [
    { id: AdminUserRoles.ROLE_ADMIN_ROOT, name: 'Tech (solo Cooler)' },
//    { id: AdminUserRoles.ROLE_ADMIN_PRODUCT, name: 'Producto (ATS + Cooler)' },
    { id: AdminUserRoles.ROLE_ADMIN_CS, name: 'Customer Success (ATS + Cooler)' },
    { id: AdminUserRoles.ROLE_ADMIN_FINANCE, name: 'Finanzas (ATS + Cooler)' }
]

export {UserRoles}